// extracted by mini-css-extract-plugin
export default {"breadCrumbContainer":"BreadCrumb_breadCrumbContainer__fnejf","breadCrumbItem":"BreadCrumb_breadCrumbItem__l1im4","breadCrumbActiveItem":"BreadCrumb_breadCrumbActiveItem__glML+"};